module.exports = __webpack_public_path__ + "img/appStore.3f89ea87.png";